<template>
  <div>
    <b-row>
      <b-col>
        <div class="flex-column mt-4">
          <div class="d-flex justify-content-between align-items-center">
            <p>The following work orders are <strong>waiting</strong> to be shipped</p>
            <div>
              <b-button size="sm" variant="primary" :disabled="selectedWO == 0 || isGettingInventories" @click="onShowPickList" class="mr-2">
                <i v-show="isGettingInventories" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                {{ isGettingInventories ? 'Getting' : '' }} Pick List
              </b-button>
            </div>
          </div>
        </div>
        <filters-component :filters="woToBeShippedFilters" :keyNdx="1" @onSearch="getData"/>
        <work-orders-list
          :serviceOrdersParentList="woToBeShippedList"
          :gridId="gridId"
          isParentList
          hideEdit
          @selectedServiceOrder="onSOSelect"
          @onSort="onSort"
          class="mt-1" />

      </b-col>
      <pick-list-modal
        :pickTicketList="woInventoryForShipping"
        :modalId="modalId"
        :serviceOrderId="selectedWO"
        @refreshData="getData"  />
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

/*import moment from 'moment';*/
import { DATE_FORMAT, GRID_ID } from '@/shared/constants';
import WorkOrdersList from '@/shared/components/ServiceOrders';
import PickListModal from '@/pages/ShippingReceiving/components/WorkOrdersTab/components/PickList';
/*import { filter } from 'minimatch';
import debounce from 'lodash/debounce';*/
import FiltersComponent from '../../components/Filters';

const PROCESS_DEBOUNCE_TIME = 750;

export default {
  components: {
    PickListModal,
    WorkOrdersList,
    FiltersComponent
  },
  data() {
    return {
      DATE_FORMAT,
      woToBeShippedFilters: {},
      selectedWO: 0,
      listName: 'woToBeShippedList',
      gridId: GRID_ID.WORK_ORDERS_TO_BE_SHIPPED,
      modalId: 'work-order-pick-list',
      isGettingInventories: false
    };
  },
  computed: {
    ...mapGetters('shippingReceiving', ['woToBeShippedList', 'woInventoryForShipping', 'woPageInfo']),
  },
  methods: {
    ...mapActions('shippingReceiving', ['getWoToBeShipped', 'getInventoriesForWO', 'setSortInfo']),
    ...mapMutations('shippingReceiving', ['setItem']),
    async getData() {
      /*this.setList({ key: this.scheduleListName, value: [] });*/
      await this.getWoToBeShipped({
        filters: {
          ...this.woToBeShippedFilters,
        }
      })

    },
    async onSOSelect($event) {
      this.isGettingInventories = true;
      this.selectedWO = $event.id;
      this.setItem({ resource: 'woInventoryForShipping', payload: [] });
      await this.getInventoriesForWO($event.id);
      this.isGettingInventories = false;
    },
    onShowPickList() {
      this.$bvModal.show(this.modalId);
    },
    onSort(evt) {
      this.setSortInfo({ ...evt, pageInfoState: 'woPageInfo' });
    }
  },
  watch: {
    woPageInfo() {
      this.getData()
    }
  },
  mounted() {
    this.setItem({ resource: this.listName, payload: [] });
    this.getData();
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>